if (!customElements.get('mega-countdown')) {
  class MegaCountdown extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.startDate = this.parseDate('start');
      this.endDate = this.parseDate('end');

      if (!Number.isFinite(this.startDate) || !Number.isFinite(this.endDate) || this.endDate <= this.startDate) {
        this.hidden = true;
        return;
      }

      this.targets = {
        days: this.querySelector('[data-countdown-days]'),
        hours: this.querySelector('[data-countdown-hours]'),
        minutes: this.querySelector('[data-countdown-minutes]'),
        seconds: this.querySelector('[data-countdown-seconds]'),
      };

      this.update();
      this.timer = window.setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      this.stop();
    }

    parseDate(prefix) {
      const months = {
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12,
      };
      const year = String(this.dataset[`${prefix}Year`] || '').trim();
      const month = months[this.dataset[`${prefix}Month`]];
      const day = Number.parseInt(this.dataset[`${prefix}Day`] || '', 10);
      const time = this.dataset[`${prefix}Time`] || '00:00:00';
      const timezone = /^[-+]\d{2}:\d{2}$/.test(this.dataset.timezone || '') ? this.dataset.timezone : '+00:00';

      if (!/^\d{4}$/.test(year) || !month || !Number.isInteger(day) || day < 1 || day > 31) return NaN;

      const isoDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}T${time}${timezone}`;
      return Date.parse(isoDate);
    }

    update() {
      const now = Date.now();
      const isActive = now >= this.startDate && now < this.endDate;
      this.hidden = !isActive;
      if (!isActive) return;

      const remaining = Math.max(0, this.endDate - now);
      const values = {
        days: Math.floor(remaining / 86400000),
        hours: Math.floor((remaining / 3600000) % 24),
        minutes: Math.floor((remaining / 60000) % 60),
        seconds: Math.floor((remaining / 1000) % 60),
      };

      if (this.targets.days) this.targets.days.textContent = String(values.days);
      if (this.targets.hours) this.targets.hours.textContent = String(values.hours).padStart(2, '0');
      if (this.targets.minutes) this.targets.minutes.textContent = String(values.minutes).padStart(2, '0');
      if (this.targets.seconds) this.targets.seconds.textContent = String(values.seconds).padStart(2, '0');
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  customElements.define('mega-countdown', MegaCountdown);
}
